__turbopack_context__.v({
  "active": "PricingPlans-module__n7nmVW__active",
  "btn": "PricingPlans-module__n7nmVW__btn",
  "btnOutline": "PricingPlans-module__n7nmVW__btnOutline",
  "btnPrimary": "PricingPlans-module__n7nmVW__btnPrimary",
  "card": "PricingPlans-module__n7nmVW__card",
  "checkIcon": "PricingPlans-module__n7nmVW__checkIcon",
  "container": "PricingPlans-module__n7nmVW__container",
  "currency": "PricingPlans-module__n7nmVW__currency",
  "featureItem": "PricingPlans-module__n7nmVW__featureItem",
  "featuresList": "PricingPlans-module__n7nmVW__featuresList",
  "period": "PricingPlans-module__n7nmVW__period",
  "planDescription": "PricingPlans-module__n7nmVW__planDescription",
  "planName": "PricingPlans-module__n7nmVW__planName",
  "plansGrid": "PricingPlans-module__n7nmVW__plansGrid",
  "popularBadge": "PricingPlans-module__n7nmVW__popularBadge",
  "popularCard": "PricingPlans-module__n7nmVW__popularCard",
  "price": "PricingPlans-module__n7nmVW__price",
  "priceBlock": "PricingPlans-module__n7nmVW__priceBlock",
  "saveBadge": "PricingPlans-module__n7nmVW__saveBadge",
  "section": "PricingPlans-module__n7nmVW__section",
  "toggleContainer": "PricingPlans-module__n7nmVW__toggleContainer",
  "toggleHandle": "PricingPlans-module__n7nmVW__toggleHandle",
  "toggleLabel": "PricingPlans-module__n7nmVW__toggleLabel",
  "toggleSwitch": "PricingPlans-module__n7nmVW__toggleSwitch",
  "toggled": "PricingPlans-module__n7nmVW__toggled",
});
